import LookInside from './LookInside';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import { setCloseOverlay, setOpenOverlay } from '../../../store/actions/app';

const enhance = compose(
  connect(
    null,
    dispatch => ({
      openOverlay: scrollPos => dispatch(setOpenOverlay(scrollPos)),
      closeOverlay: () => dispatch(setCloseOverlay()),
    }),
  ),
  withState('isOpen', 'setIsOpen', props => props.isOpen),
  withHandlers({
    handleOpenModal: props => e => {
      e.preventDefault();
      props.openOverlay(window.scrollY);
      props.setIsOpen(true);
    },
    handleCloseModal: props => () => {
      props.closeOverlay();
      props.setIsOpen(false);
    },
    handleAcceptModal: props => () => {
      if (typeof props.onLookInsideMain === 'function') {
        props.onLookInsideMain();
      }
      props.closeOverlay();
      props.setIsOpen(false);
    },
    handleCancelModal: props => () => {
      if (typeof props.onLookInsideCancel === 'function') {
        props.onLookInsideCancel();
      }
      props.closeOverlay();
      props.setIsOpen(false);
    },
  }),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      if (props.isOpen) {
        props.openOverlay(window.scrollY);
      }
    }
  })
);

export default enhance(LookInside);



// WEBPACK FOOTER //
// ./src/client/js/view/components/LookInside/index.js